import { FC } from 'react'

import { datadogRum } from '@datadog/browser-rum'

import { Button, Cluster, Icon, Link, Stack, Typography, useToaster } from '@forto-dev/phoenix-ui-core/common'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { Navigation } from '@/fragments/navigation'
import { useLocalisation } from '@/utils/localisation'

export const Support: FC = () => {
  const { translate } = useLocalisation()
  const sessionReplaySessionLink = datadogRum.getSessionReplayLink()
  const toaster = useToaster()

  return (
    <Layout
      header={<Header />}
      navigation={<Navigation />}
      title={<Typography variant="h4">{translate('support.title')}</Typography>}
      main={
        <Stack gap={16}>
          <Typography variant="body">{translate('support.instructions.intro')}</Typography>
          <Stack gap={4}>
            <Link href={translate('support.instructions.link')}>{translate('support.instructions.contact')}</Link>
          </Stack>
          {sessionReplaySessionLink ? (
            <>
              <Typography variant="body">{translate('support.replay.intro')}</Typography>
              <Button
                onClick={async () => {
                  await navigator.clipboard.writeText(sessionReplaySessionLink)
                  toaster({
                    title: translate('support.notifications.clipboard'),
                  })
                }}
              >
                <Cluster gap={8} y="center">
                  <Icon name="FileCopy" /> {translate('support.replay.actions.copy')}
                </Cluster>
              </Button>
            </>
          ) : null}
        </Stack>
      }
      footer={<Footer />}
    />
  )
}
